import { useRef, useState } from "react";
import Navigation from "../components/Navigation";
import HeroSection from "../components/sections/HeroSection";
import DiscoverSection from "../components/sections/DiscoverSection";
import InvestmentLifestyleSection from "../components/sections/InvestmentLifestyleSection";
import PlayaChahueSection from "../components/sections/PlayaChahueSection";
import DestinationSection from "../components/sections/DestinationSection";
import DevelopmentSection from "../components/sections/DevelopmentSection";
import ProjectBackingSection from "../components/sections/ProjectBackingSection";
import PurchaseProcessSection from "../components/sections/PurchaseProcessSection";
import InvestmentOpportunitySection from "../components/sections/InvestmentOpportunitySection";
import PlannedByDesignSection from "../components/sections/PlannedByDesignSection";
import FAQSection from "../components/sections/FAQSection";
import ContactSection from "../components/sections/ContactSection";
import Footer from "../components/sections/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import WhatsAppFormModal from "../components/WhatsAppFormModal";

const LandingPage = () => {
  const contactRef = useRef(null);
  const [whatsAppOpen, setWhatsAppOpen] = useState(false);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const openWhatsApp = () => setWhatsAppOpen(true);
  const closeWhatsApp = () => setWhatsAppOpen(false);

  return (
    <>
      {/* GTM-MR5ZSPMT is installed in public/index.html (head + noscript).
          Do NOT duplicate the snippet here — pasting the IIFE inside JSX
          breaks the build because curly braces are parsed as expressions. */}
      <main className="min-h-screen bg-white" data-testid="landing-page">
        {/* Navigation Menu */}
        <Navigation />
        
        {/* Floating WhatsApp Button */}
        <FloatingWhatsApp onOpenWhatsApp={openWhatsApp} />
        
        {/* WhatsApp Form Modal */}
        <WhatsAppFormModal isOpen={whatsAppOpen} onClose={closeWhatsApp} />
        
        {/* Hero Section with Video Background */}
        <HeroSection scrollToContact={scrollToContact} onOpenWhatsApp={openWhatsApp} />
        
        {/* Discover the Project */}
        <div id="discover">
          <DiscoverSection />
        </div>
        
        {/* Investment & Lifestyle */}
        <div id="investment">
          <InvestmentLifestyleSection />
        </div>
        
        {/* Playa Chahué */}
        <div id="location">
          <PlayaChahueSection />
        </div>
        
        {/* The Destination - Huatulco */}
        <DestinationSection />
        
        {/* The Development */}
        <div id="development">
          <DevelopmentSection />
        </div>
        
        {/* Project Backing */}
        <ProjectBackingSection />
        
        {/* Purchase Process */}
        <PurchaseProcessSection />
        
        {/* Investment Opportunity */}
        <InvestmentOpportunitySection scrollToContact={scrollToContact} onOpenWhatsApp={openWhatsApp} />
        
        {/* Planned by Design - FONATUR */}
        <PlannedByDesignSection />
        
        {/* FAQ */}
        <div id="faq">
          <FAQSection />
        </div>
        
        {/* Contact Section */}
        <div ref={contactRef} id="contact">
          <ContactSection onOpenWhatsApp={openWhatsApp} />
        </div>
        
        {/* Footer */}
        <Footer />
      </main>
    </>
  );
};

export default LandingPage;